<template>
  <div class="properties-skeleton-grid">
    <div
      v-for="index in 8"
      :key="index"
      class="property-skeleton-card"
      data-testid="property-skeleton-card"
    >
      <div class="property-skeleton-image shimmer"></div>
      <div class="property-skeleton-line short shimmer"></div>
      <div class="property-skeleton-line long shimmer"></div>
      <div class="property-skeleton-actions">
        <div class="property-skeleton-btn shimmer"></div>
        <div class="property-skeleton-btn shimmer"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PropertiesSkeleton'
}
</script>

<style scoped>
.properties-skeleton-grid {
  display: grid;
  gap: 12px;
  grid-auto-flow: row;
  grid-template-columns: repeat(auto-fill, 270px);
  justify-content: center;
}
.property-skeleton-card {
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 16px 0 rgba(43, 45, 55, 0.05);
  display: flex;
  flex-flow: column nowrap;
  gap: 12px;
  padding: 12px;
  min-height: 350px;
}
.property-skeleton-image {
  background-color: #e3e5e8;
  border-radius: 5px;
  height: 200px;
  width: 100%;
  overflow: hidden;
  position: relative;
}
.property-skeleton-line {
  background-color: #e3e5e8;
  border-radius: 4px;
  height: 15px;
  overflow: hidden;
  position: relative;
}
.property-skeleton-line.short {
  width: 60%;
}
.property-skeleton-line.long {
  width: 90%;
}
.property-skeleton-actions {
  display: flex;
  justify-content: space-between;
  margin-top: auto;
}
.property-skeleton-btn {
  background-color: #e3e5e8;
  border-radius: 4px;
  height: 32px;
  width: 30%;
  overflow: hidden;
  position: relative;
}
.shimmer::after {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.7),
    transparent
  );
  animation: shimmerMove 1.6s linear infinite;
}
@keyframes shimmerMove {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}
@media screen and (max-width: 648px) {
  .properties-skeleton-grid {
    grid-template-columns: 1fr;
  }
}
</style>
